import { replace } from 'react-router-redux';
import { HIDE_MODAL } from '../actions/hide-modal';
import * as modalTypes from '../constants/modal-types';
import { createPost } from '../actions/create-post';
import { movePost } from '../actions/move-post';
import changeCategory from '../actions/change-category';
import { deletePost } from '../actions/delete-post';
import { deleteComment } from '../actions/delete-comment';
import { deleteCategory } from '../actions/delete-category';
import { reportComment } from '../actions/report-comment';
import { reportPost } from '../actions/report-post';
import { reportUser } from '../actions/report-user';
import { insertTextEditorLink } from '../actions/insert-text-editor-link';
import { insertTextEditorVideoEmbed } from '../actions/insert-text-editor-video-embed';
import { promoteModerator } from '../actions/promote-moderator';
import { demoteModerator } from '../actions/demote-moderator';
import { toggleUserSubscribe } from '../actions/toggle-user-subscribe';
import { blockUser } from '../actions/block-user';
import { unblockUser } from '../actions/unblock-user';
import { openSettingsDialog } from '../actions/open-settings-dialog';
import messages, * as messageTypes from '../components/message/messages';

export default createShowMessage => store => {
  const showMessage = createShowMessage(store);

  const ON_HIDE = {
    FOR_TEST: () => ({ type: 'TEST' }),
    [modalTypes.MODAL_TYPE_CREATE_POST]: post => createPost(post),
    [modalTypes.MODAL_TYPE_CHANGE_CATEGORY]: categoryId => dispatch => {
      return dispatch(changeCategory(categoryId)).then(() =>
        showMessage(messages[messageTypes.CATEGORY_UPDATE].content(), messages[messageTypes.CATEGORY_UPDATE].type)
      );
    },

    [modalTypes.MODAL_TYPE_DELETE_COMMENT]: payload => dispatch => {
      return dispatch(deleteComment(payload)).then(() =>
        showMessage(messages[messageTypes.COMMENT_DELETE].content(), messages[messageTypes.COMMENT_DELETE].type)
      );
    },

    [modalTypes.MODAL_TYPE_DELETE_POST]: postId => dispatch => {
      return dispatch(deletePost(postId)).then(() =>
        showMessage(messages[messageTypes.POST_DELETE].content(), messages[messageTypes.POST_DELETE].type)
      );
    },

    [modalTypes.MODAL_TYPE_DELETE_CATEGORY]: categoryId => dispatch => {
      return dispatch(deleteCategory(categoryId)).then(() =>
        showMessage(messages[messageTypes.COMMENT_DELETE].content(), messages[messageTypes.COMMENT_DELETE].type)
      );
    },

    [modalTypes.MODAL_TYPE_DISCARD_POST]: categorySlug => replace(`/${categorySlug}`),

    [modalTypes.MODAL_TYPE_PROMOTE_MODERATOR]: userId => dispatch => {
      return dispatch(promoteModerator(userId)).then(() =>
        showMessage(
          messages[messageTypes.MEMBER_PROMOTE_MODERATOR].content(),
          messages[messageTypes.MEMBER_PROMOTE_MODERATOR].type
        )
      );
    },

    [modalTypes.MODAL_TYPE_DEMOTE_MODERATOR]: userId => dispatch => {
      return dispatch(demoteModerator(userId)).then(() =>
        showMessage(
          messages[messageTypes.MEMBER_DEMOTE_MODERATOR].content(),
          messages[messageTypes.MEMBER_DEMOTE_MODERATOR].type
        )
      );
    },

    [modalTypes.MODAL_TYPE_UNFOLLOW_MEMBER]: userId => toggleUserSubscribe(userId),

    [modalTypes.MODAL_TYPE_BLOCK_MEMBER]: userId => dispatch => {
      return dispatch(blockUser(userId)).then(() =>
        showMessage(messages[messageTypes.MEMBER_BLOCK].content(), messages[messageTypes.MEMBER_BLOCK].type)
      );
    },

    [modalTypes.MODAL_TYPE_UNBLOCK_MEMBER]: userId => dispatch => {
      return dispatch(unblockUser(userId)).then(() =>
        showMessage(messages[messageTypes.MEMBER_UNBLOCK].content(), messages[messageTypes.MEMBER_UNBLOCK].type)
      );
    },

    [modalTypes.MODAL_TYPE_MOVE_POST]: ({ postId, categoryId }) => dispatch => {
      return dispatch(movePost(postId, categoryId)).then(() =>
        showMessage(messages[messageTypes.POST_MOVE].content(), messages[messageTypes.POST_MOVE].type)
      );
    },

    [modalTypes.MODAL_TYPE_REPORT_COMMENT]: report => reportComment(report),

    [modalTypes.MODAL_TYPE_REPORT_POST]: report => reportPost(report),

    [modalTypes.MODAL_TYPE_REPORT_MEMBER]: report => reportUser(report),

    [modalTypes.MODAL_TYPE_TEXT_EDITOR_LINK]: data => insertTextEditorLink({ ...data }),

    [modalTypes.MODAL_TYPE_TEXT_EDITOR_VIDEO_EMBED]: data => insertTextEditorVideoEmbed({ ...data }),

    [modalTypes.MODAL_TYPE_DEMO_MODE]: data => dispatch => {
      if (data) {
        dispatch(openSettingsDialog());
      }
    },
  };

  return next => action => {
    const { type, focusOnCloseId } = store.getState().modal;
    const onHide = ON_HIDE[type];

    if (action.type === HIDE_MODAL && focusOnCloseId) {
      const element = document.getElementById(focusOnCloseId);
      element && element.focus();
    }

    if (action.type === HIDE_MODAL && onHide && action.payload) {
      store.dispatch(onHide(action.payload));
    }

    next(action);
  };
};



// WEBPACK FOOTER //
// ./app/middleware/modal-middleware.js